import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Constants } from '@app/shared-module/constants';
import { IMyDrpOptions } from 'mydaterangepicker';
import { AdminService } from '../../services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalResponse, User, Clinic } from '@app/shared-module/models';
import { CommonService } from '@app/shared-module/common-service.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-transaction-list',
  templateUrl: './transaction-list.component.html',
  styleUrls: ['./transaction-list.component.scss'],
})
export class TransactionListComponent implements OnInit {
  user: User;
  isEditEnabled = false;
  transactionList: any[] = [];
  doctorList: any[] = [];
  selectedClinicID: '';
  clinicList: Clinic[] = [];
  clinic_selected: any;
  doctor_selected: any;
  @BlockUI() blockUI: NgBlockUI;

  length = 0;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  dateRange: any;
  searchBoxInv = '';
  searchBoxCus = '';
  currentDate: Date = new Date();
  previousMonthDate: Date;
  myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: Constants.DATE_FORMAT,
    disableSince: {
      year: this.currentDate.getFullYear(),
      month: this.currentDate.getMonth() + 1,
      day: this.currentDate.getDate() + 1,
    },
    showClearDateRangeBtn: false,
    editableDateRangeField: false,
    openSelectorOnInputClick: true,
  };

  constructor(
    private adminSrv: AdminService,
    private toastr: ToastrService,
    private commonService: CommonService,
    public dialog: MatDialog
  ) {
    this.previousMonthDate = new Date(this.currentDate);
    this.previousMonthDate.setMonth(this.previousMonthDate.getMonth() - 1);
    // console.log(this.previousMonthDate);
    this.dateRange = {
      beginDate: {
        year: this.previousMonthDate.getFullYear(),
        month: this.previousMonthDate.getMonth() + 1,
        day: this.previousMonthDate.getDate(),
      },
      endDate: {
        year: this.currentDate.getFullYear(),
        month: this.currentDate.getMonth() + 1,
        day: this.currentDate.getDate(),
      },
    };
  }

  ngOnInit() {
    this.getClinicList();
    this.user = this.commonService.internalLoginValue;
    if (
      this.user &&
      this.user.role &&
      (this.user.role === Constants.ROLE_ADMIN ||
        this.user.role === Constants.ROLE_ACCOUNTS)
    ) {
      this.isEditEnabled = true;
    } else {
      this.isEditEnabled = false;
    }
  }

  fetchStaff() {
    this.blockUI.start();
    this.adminSrv
      .getDoctorList(this.selectedClinicID)
      .subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          // console.log(res.result);
          this.doctorList = res.result.doctor;
          // this.doctorList.unshift(JSON.parse(localStorage.getItem('login')));
          // this.commonService.doctorList = this.doctorList;
          if (this.doctorList && this.doctorList.length > 0) {
            for (const item of this.doctorList) {
              item.name = item.first_name + ' ' + item.last_name;
            }
            this.doctor_selected = 'All';
            // this.selectedDoctor = this.doctorList[0]._id;
          }
          this.doctorList.unshift({ name: 'All' });
          this.doctor_selected = { name: 'All' };
          this.fetchTransactionList();
        }
      });
  }

  getClinicList() {
    this.blockUI.start();
    this.adminSrv.getClinicList().subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.clinicList = res.result;
        if (this.clinicList && this.clinicList.length > 0) {
          this.clinic_selected = this.clinicList[0];
          this.selectedClinicID = this.clinic_selected._id;
          this.fetchStaff();
        }
        // console.log(this.clinicList);
      }
    });
  }

  onClinicChange = (event) => {
    if (
      this.clinic_selected &&
      this.clinic_selected.name &&
      this.clinic_selected.name !== undefined
    ) {
      this.selectedClinicID = this.clinic_selected._id;
      this.fetchStaff();
    }
  }

  onChange(event: any) {
    this.fetchTransactionList();
    if (this.doctor_selected && this.doctor_selected.name) {
      this.fetchTransactionList();
    }
  }

  changeDate(event: any) {
    // console.log(event);
    // console.log(this.dateRange);
    if (event) {
      this.dateRange = event;
    }
    this.fetchTransactionList();
  }

  pageEvent(event) {
    // console.log(this.pageSize);
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchTransactionList();
  }

  fetchTransactionList() {
    let doctorID = '';
    if (this.doctor_selected) {
      if (this.doctor_selected._id) {
        doctorID = this.doctor_selected._id;
      } else {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.doctorList.length; i++) {
          if (this.doctorList[i]._id) {
            doctorID += this.doctorList[i]._id;
            if (i + 1 < this.doctorList.length) {
              doctorID += ',';
            }
          }
        }
      }
    }
    this.blockUI.start();
    this.adminSrv
      .getTransactionList(
        this.dateRange.beginDate,
        this.dateRange.endDate,
        this.selectedClinicID,
        doctorID,
        this.searchBoxInv,
        this.searchBoxCus,
        this.pageSize,
        this.pageNumber
      )
      .subscribe(
        (res: GlobalResponse) => {
          this.blockUI.stop();
          if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
            // console.log(res.result);
            this.transactionList = res.result.payment;
            this.length = res.result.paymentCount;
          }
        },
        (error: any) => {
          this.toastr.error(error);
        }
      );
  }
}
